import script from "./progress.vue?vue&type=script&setup=true&lang=js"
export * from "./progress.vue?vue&type=script&setup=true&lang=js"

import "./progress.vue?vue&type=style&index=0&id=2c2cd87e&lang=less&scoped=true"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_vue@3.5.4_webpack@5.94.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2c2cd87e"]])

export default __exports__